module.exports = "././img/dlgrma_logo_black_transparent.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/dlgrma_logo_black_transparent.png
// module id = 819
// module chunks = 0